import type { PropsWithChildren } from "react";
import {
  getSupportedTileAggregationTypes,
  supportedTileAggregations,
} from "../../../../utilities/aggregationHelper.ts";
import { SupportedAggregationsContextProvider } from "../../../viewer/common/context/SupportedAggregationsContextProvider.tsx";

const TileContainer = ({ children }: PropsWithChildren) => {
  return (
    <SupportedAggregationsContextProvider
      aggregations={supportedTileAggregations}
      getSupportedAggregationTypes={getSupportedTileAggregationTypes}
    >
      {children}
    </SupportedAggregationsContextProvider>
  );
};

export default TileContainer;
